import { CrossSellingContent } from '../../../../interfaces/CrossSellingContent';
import { CrossSellingDto } from '../../../../interfaces/Dto/CrossSellingDto';

export default function transformData(crossSellingDto: CrossSellingDto): CrossSellingContent {
  const crossSellingData: CrossSellingContent[] = [];
  crossSellingDto?.sitecore?.route?.placeholders?.Jss[0]?.fields?.banners?.forEach((f) => {
    crossSellingData.push({
      imageSrc: f.image.src,
      title: f.title,
      text: f.text,
      linkText: f.link.text,
      linkHref: f.link.href,
      backgroundColor: f.backgroundColor,
    });
  });

  return crossSellingData[0];
}
